export default "__VITE_ASSET__Mo2R05Qm__"